import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { INVITE_STATE } from 'garaje/utils/enums';
import { format, subMinutes, fromUnixTime } from 'date-fns';

/**
 * @param {gqlEntry}          entry             graphql representation of an entry
 * @param {gqlReservation}    reservation       graphql representation of a reservation
 * @param {gqlInvite}         invite            graphql representation of an invite
 * @param {number}            maxOccupancy      amount allowed in the office
 * @param {number}            peopleRegistered  total amount of people with invites for the day (not desk reservations)
 */
let ReservationCardComponent = (_class = class ReservationCardComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
    _initializerDefineProperty(this, "metrics", _descriptor3, this);
    _initializerDefineProperty(this, "registrations", _descriptor4, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor5, this);
    _initializerDefineProperty(this, "unscheduleModalIsOpen", _descriptor6, this);
    _initializerDefineProperty(this, "unscheduleError", _descriptor7, this);
    _defineProperty(this, "INVITE_STATE_ENUM", INVITE_STATE);
    _defineProperty(this, "unscheduleTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.unscheduleError = false;
        try {
          const {
            date,
            allReservationsForDay
          } = this.args;
          const reservationIds = allReservationsForDay.map(res => res.id);
          const {
            invite,
            unscheduledReservation
          } = yield this.registrations.unschedulePartialDay(date, {
            reservationIds
          });
          this.metrics.trackEvent('Web Employee Schedule - Unschedule', {
            desk_id: unscheduledReservation?.desk?.id,
            invite_date: invite.expectedArrivalTime,
            invite_id: invite.id,
            invite_location_id: invite.location.id,
            reservation_id: unscheduledReservation?.id
          });
          this.unscheduleModalIsOpen = false;
          this.flashMessages.showAndHideFlash('success', 'Reservation released');
        } catch (e) {
          this.unscheduleError = true;
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "unscheduleTask", null));
    _defineProperty(this, "releaseDeskReservationTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          reservation
        } = this.args;
        try {
          yield this.registrations.releaseDeskPartialDay({
            reservation
          });
          this.metrics.trackEvent('Web Employee Schedule - Release Desk', {
            reservation_id: reservation.id,
            desk_id: reservation.desk.id
          });
          this.flashMessages.showAndHideFlash('success', 'Desk released');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "releaseDeskReservationTask", null));
    _defineProperty(this, "checkInReservationTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          reservation,
          date
        } = this.args;
        try {
          yield this.registrations.checkInReservation(date, {
            reservationId: reservation.id
          });
          this.metrics.trackEvent('Web Employee Schedule - Check In Reservation', {
            reservation_id: reservation.id
          });
          this.flashMessages.showAndHideFlash('success', 'Checked in reservation');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "checkInReservationTask", null));
    _defineProperty(this, "checkOutReservationTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          reservation,
          date
        } = this.args;
        try {
          yield this.registrations.checkOutReservation(date, {
            reservationId: reservation.id
          });
          this.metrics.trackEvent('Web Employee Schedule - Check Out Reservation', {
            reservation_id: reservation.id
          });
          this.flashMessages.showAndHideFlash('success', 'Checked out reservation');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "checkOutReservationTask", null));
  }
  getLocationTime(time) {
    return subMinutes(fromUnixTime(time), this.state.minutesBetweenTimezones);
  }
  get partialTimeDisplay() {
    const {
      reservation
    } = this.args;
    const startTime = format(this.getLocationTime(reservation.startTime), 'h:mma');
    const endTime = format(this.getLocationTime(reservation.endTime), 'h:mma');
    return `${startTime} - ${endTime}`;
  }
  get isEditReservationConfigEnabled() {
    return this.featureConfig.isEnabled('deskReservations.editing');
  }
  get isCancelReservationConfigEnabled() {
    return this.featureConfig.isEnabled('deskReservations.canceling');
  }
  get isCheckInReservationConfigEnabled() {
    return this.featureConfig.isEnabled('deskReservations.checkingIn');
  }
  get showDelegatedBookerName() {
    return this.delegatedBookerName;
  }
  get delegatedBookerName() {
    const {
      invite
    } = this.args;
    if (!invite?.employee?.email || !invite?.visitor?.email) {
      return null;
    }
    if (invite.employee.email === invite.visitor.email) {
      return null;
    }
    return invite.employee.name;
  }
  closeUnscheduleModal() {
    this.unscheduleError = false;
    this.unscheduleModalIsOpen = false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "metrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "registrations", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "unscheduleModalIsOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "unscheduleError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "closeUnscheduleModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeUnscheduleModal"), _class.prototype)), _class);
export { ReservationCardComponent as default };